export const PROJECT_TEMPLATES_FETCH = 'PROJECT_TEMPLATES_FETCH'
export const PROJECT_TEMPLATES_FETCH_SUCCESS = 'PROJECT_TEMPLATES_FETCH_SUCCESS'
export const PROJECT_TEMPLATES_FETCH_FAILURE = 'PROJECT_TEMPLATES_FETCH_FAILURE'

export const PROJECT_TEMPLATE_CREATE = 'PROJECT_TEMPLATE_CREATE'
export const PROJECT_TEMPLATE_CREATE_SUBMIT = 'PROJECT_TEMPLATE_CREATE_SUBMIT'
export const PROJECT_TEMPLATE_CREATE_FAILURE = 'PROJECT_TEMPLATE_CREATE_FAILURE'

export const PROJECT_TEMPLATE_DELETE = 'PROJECT_TEMPLATE_DELETE'
export const PROJECT_TEMPLATE_DELETE_SUCCESS = 'PROJECT_TEMPLATE_DELETE_SUCCESS'
export const PROJECT_TEMPLATE_DELETE_FAILURE = 'PROJECT_TEMPLATE_DELETE_FAILURE'

export const PROJECT_TEMPLATE_UPDATE = 'PROJECT_TEMPLATE_UPDATE'
export const PROJECT_TEMPLATE_UPDATE_SUBMIT = 'PROJECT_TEMPLATE_UPDATE_SUBMIT'
export const PROJECT_TEMPLATE_UPDATE_FAILURE = 'PROJECT_TEMPLATE_UPDATE_FAILURE'

export const PROJECT_TEMPLATE_TOGGLE_ENABLE = 'PROJECT_TEMPLATE_TOGGLE_ENABLE'
export const PROJECT_TEMPLATE_TOGGLE_ENABLE_SUCCESS = 'PROJECT_TEMPLATE_TOGGLE_ENABLE_SUCCESS'
export const PROJECT_TEMPLATE_TOGGLE_ENABLE_FAILURE = 'PROJECT_TEMPLATE_TOGGLE_ENABLE_FAILURE'
